/** Plateforme LyrraStudio (établissements / OF). */
export type PlatformMode = 'lyrraone' | 'studio';

export function getPlatformMode(): PlatformMode {
  const raw = (import.meta.env.VITE_PLATFORM_MODE ?? 'studio').toLowerCase();
  return raw === 'lyrraone' ? 'lyrraone' : 'studio';
}

export function isLyrraOne(): boolean {
  return getPlatformMode() === 'lyrraone';
}

export function getAppName(): string {
  if (isLyrraOne()) return 'LyrraOne';
  const fromEnv = import.meta.env.VITE_APP_NAME;
  if (typeof fromEnv === 'string' && fromEnv.trim() !== '') return fromEnv.trim();
  return 'Stratelya';
}

/** Liste des formations formateur : onglet dashboard en LyrraOne, page dédiée en Studio. */
export function formateurFlowsListPath(query?: Record<string, string | undefined>): string {
  const params = new URLSearchParams();
  if (isLyrraOne()) {
    params.set('tab', 'flows');
  }
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      if (value != null && value !== '') params.set(key, value);
    }
  }
  const base = isLyrraOne() ? '/dashboard' : '/eduflow/list';
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

/** Liste des podcasts / supports formateur : onglet dashboard en LyrraOne, page dédiée en Studio. */
export function formateurSupportsListPath(query?: Record<string, string | undefined>): string {
  const params = new URLSearchParams();
  if (isLyrraOne()) {
    params.set('tab', 'supports');
  }
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      if (value != null && value !== '') params.set(key, value);
    }
  }
  const base = isLyrraOne() ? '/dashboard' : '/podcasts';
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
